<template>
  <div class="main">
    <router-view name="header"></router-view>
    <div class="content">
      <router-view name="leftMenu"></router-view>
      <router-view />
    </div>
    <router-view name="footer"></router-view>
  </div>
</template>
<script>
import "@/scss/main.scss";

export default {};
</script>
